import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-view",
  "use": "icon-view-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-view\"><path d=\"M512 128C229.274 128 0 386.048 0 512s229.274 384 512 384 512-286.72 512-384-229.274-384-512-384z m0 722.944C254.157 850.944 45.056 623.206 45.056 512S254.156 173.056 512 173.056 978.944 426.086 978.944 512 769.844 850.944 512 850.944z\" /><path d=\"M512 327.68c-101.786 0-184.32 82.534-184.32 184.32S410.214 696.32 512 696.32 696.32 613.786 696.32 512 613.786 327.68 512 327.68z m0 323.584c-76.902 0-139.264-62.362-139.264-139.264S435.098 372.736 512 372.736 651.264 435.098 651.264 512 588.902 651.264 512 651.264z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/view.svg
// module id = zjNx
// module chunks = 65